import { GetListParams, GetOneParams } from 'react-admin';
import { baseUrl, httpClient } from '../../providers/AppDataProvider';
import { CustomDataProvider } from '../../providers/CustomDataProvider';
import { Resources } from '../resource';
import { HotSymbolCandidate, HotSymbolPinsData } from './types';

// 对接 admin BE src/modules/hot-symbols（透传 goback admin GraphQL）：
//   getList -> GET  /hot-symbols/candidates  候选池（上游已按 24h 成交量降序）
//   getOne  -> GET  /hot-symbols/pins        当前置顶配置 + slots 预览
//   update  -> PUT  /hot-symbols/pins        全量覆盖置顶（pinned 顺序即优先级，[] 清空）
export class HotSymbolsDataProvider implements CustomDataProvider {
  // eslint-disable-next-line class-methods-use-this
  async getList(resource: string, _params: GetListParams): Promise<any> {
    if (resource !== Resources.hotSymbols) {
      return Promise.reject(new Error('Unsupported getList resource'));
    }

    const { json } = await httpClient(`${baseUrl}/hot-symbols/candidates`, { method: 'GET' });
    const list: HotSymbolCandidate[] = json?.data ?? [];

    return {
      data: list.map((item) => ({ ...item, id: item.symbol })),
      total: json?.total ?? list.length,
    };
  }

  // eslint-disable-next-line class-methods-use-this
  async getOne(resource: string, _params: GetOneParams): Promise<any> {
    if (resource !== Resources.hotSymbols) {
      return Promise.reject(new Error('Unsupported getOne resource'));
    }

    const { json } = await httpClient(`${baseUrl}/hot-symbols/pins`, { method: 'GET' });
    const data: HotSymbolPinsData = json?.data ?? {};

    return { data: { ...data, id: 'pins' } };
  }

  // eslint-disable-next-line class-methods-use-this
  async update(resource: string, params: any): Promise<any> {
    if (resource !== Resources.hotSymbols) {
      return Promise.reject(new Error('Unsupported update resource'));
    }

    const pinned: string[] = params?.data?.pinned ?? [];
    const slotCount: number | undefined = params?.data?.slotCount;

    const { json } = await httpClient(`${baseUrl}/hot-symbols/pins`, {
      method: 'PUT',
      body: JSON.stringify({
        pinned,
        // 省略 slotCount 表示保持当前值
        ...(slotCount !== undefined ? { slotCount } : {}),
      }),
    });

    return { data: { ...(json?.data ?? {}), id: 'pins', message: json?.message } };
  }
}

export const hotSymbolsDataProvider = new HotSymbolsDataProvider();
